export const ComplectsOffers = {
	inject: ['offerslist'],
    props: {
        classprefix: {default:''},
    },
    data () {
        return {
            offers: this.offerslist,
            selectedOfferId: false
        }
    },
    created () {
        if (!this.selectedOfferId) {
            this.selectedOfferId=this.offerslist[0].ID;
        }
    },
    methods: {
        set (OfferId)
        {
			this.selectedOfferId=OfferId;
        }
    },
	template: `
    <div class="selection-dobornye-wrapper">

        <slot v-if="selectedOfferId" v-bind:name="'offerid-'+selectedOfferId"></slot>

        <div class="collection_additional_content">

            <a 
                    class="additional_palette_block"
                    v-for="offer in offers"
                    v-bind:href="offer.DETAIL_PAGE_URL"
                    v-on:click.prevent="set(offer.ID)"
                >
                <picture class="tile_thumbnail">
                    <img v-bind:src="offer.PICTURE_SRC" v-bind:alt="offer.NAME">
                </picture>
                <span class="additional_palette_name" v-if="offer.COLOR?.UF_NAME">{{offer.COLOR.UF_NAME}}</span>


                <div v-if="offer.ID == selectedOfferId" class="active_marker" width="30" height="30">
                    <img src="/local/assets/dist/img/index/collection/active.svg" alt="Select">
                </div>

            </a>
            
        </div>
    </div>
	`
}
